function checkWorkPosition(num) {
  return num % 2 === 0
    ? {
        justifyContent: "end",
        marginTop: "68px",
      }
    : { justifyContent: "start" };
}

export default checkWorkPosition;
